<template lang="pug">
.efight-mainmarket-group.efight2(:class="{ 'm-0 mt-1': source.items[0].marketId == 3 }")
  //- small {{ source.items[0].details['oe'][0] }}
  .efight-mainmarket-item(
    v-if="source != null"
    type='button' 
    :id="source.items[0].id"
    :class="{ 'collapsed': source.items[0].marketId != 3 }"
    :data-toggle="source.items[0].marketId == 3 ? '' : 'collapse'"
    :data-target="source.items[0].marketId == 3 ? '' : '#mainmarket-' + source.items[0].matchId"
  )
    .row.mainmarket-item-top
      efTimer(:source="source.items[0]" :horiz="false" :class="{ 'd-none' : source.items[0].marketId == 3 }")
      .live-icon-wrapper(:class="{ 'd-none' : source.items[0].marketId != 3 }")
        img.live-icon(src='images/egame/live-icon.svg')
        span.mx-1 LIVE
        .live-dot
    .mainmarket-item-match
      .team1
        img.characters(:src="getImage(source.items[0].sportsId, source.items[0].matchBody[22])")
        span.name {{ source.items[0].homeTeam }}
      .vs
        img.img-fluid(src='images/egame/vs.svg')
      .team2
        img.characters(:src="getImage(source.items[0].sportsId, source.items[0].matchBody[23])")
        span.name {{ source.items[0].awayTeam }}
  .collapse.show(
    v-if="source.items[0].marketId != 3"
    :id="'mainmarket-' + source.items[0].matchId"
  )
    .match-collapse-body
      .efight-marketgroup-content
        .row.justify-content-center.m-0.mt-2
          .col-6.efight-odds-group
            .efight-odds.d-block
              .bettype-col {{ $t("m.CF_MLHOME") }}
              template(v-if="source.items[0] && source.items[0].details['ml'] && source.items[0].details['ml'][0] && source.items[0].details['ml'][0][5] != 0 && source.items[0].details['ml'][0][5] != ''")
                OddsItem(:odds="source.items[0].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
              template(v-else)
                OddsDisabled                
            .row.m-0
              .efight-odds.d-block
                .bettype-col {{ $t("m.CF_CS_2_1") }}
                template(v-if="source.items[0] && source.items[0].details['cs'] && source.items[0].details['cs'][3] && source.items[0].details['cs'][3][5] != 0 && source.items[0].details['cs'][3][5] != ''")
                  OddsItem(:odds="source.items[0].details['cs'][3]" idx=5 :typ="oddsType" dataType="3")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block
                .bettype-col {{ $t("m.CF_CS_2_0") }}
                template(v-if="source.items[0] && source.items[0].details['cs'] && source.items[0].details['cs'][2] && source.items[0].details['cs'][2][5] != 0 && source.items[0].details['cs'][2][5] != ''")
                  OddsItem(:odds="source.items[0].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                template(v-else)
                  OddsDisabled
            .row.m-0.flex-nowrap
              .efight-odds.d-block(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && racingList7.includes(source.items[0].sportsId)")
                .bettype-col {{ $t("m.CF_R_3_W") }}
                template(v-if="source.items[3] && source.items[3].details['ml'] && source.items[3].details['ml'][0] && source.items[3].details['ml'][0][5] != 0 && source.items[3].details['ml'][0][5] != ''")
                  OddsItem(:odds="source.items[3].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block
                .bettype-col {{ $t("m.CF_R_2_W") }}
                template(v-if="source.items[2] && source.items[2].details['ml'] && source.items[2].details['ml'][0] && source.items[2].details['ml'][0][5] != 0 && source.items[2].details['ml'][0][5] != ''")
                  OddsItem(:odds="source.items[2].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block
                .bettype-col {{ $t("m.CF_R_1_W") }}
                template(v-if="source.items[1] && source.items[1].details['ml'] && source.items[1].details['ml'][0] && source.items[1].details['ml'][0][5] != 0 && source.items[1].details['ml'][0][5] != ''")
                  OddsItem(:odds="source.items[1].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
            .row.m-0.flex-nowrap(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && racingList7.includes(source.items[0].sportsId)")
              .efight-odds.d-block
                .bettype-col {{ $t("m.EF8_R3_1STBOOM") }}
                template(v-if="source.items[6] && source.items[6].details['ml'] && source.items[6].details['ml'][0] && source.items[6].details['ml'][0][5] != 0 && source.items[6].details['ml'][0][5] != ''")
                  OddsItem(:odds="source.items[6].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block
                .bettype-col {{ $t("m.EF8_R2_1STBOOM") }}
                template(v-if="source.items[5] && source.items[5].details['ml'] && source.items[5].details['ml'][0] && source.items[5].details['ml'][0][5] != 0 && source.items[5].details['ml'][0][5] != ''")
                  OddsItem(:odds="source.items[5].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
            .row.m-0.flex-nowrap
              .efight-odds.d-block(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && racingList7.includes(source.items[0].sportsId)")
                .bettype-col {{ $t("m.EF8_R1_1STBOOM") }}
                template(v-if="source.items[4] && source.items[4].details['ml'] && source.items[4].details['ml'][0] && source.items[4].details['ml'][0][5] != 0 && source.items[4].details['ml'][0][5] != ''")
                  OddsItem(:odds="source.items[4].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && !racingList7.includes(source.items[0].sportsId)")
                .bettype-col {{ $t("m.CF_R_1_W") }}
                template(v-if="source.items[1] && source.items[1].details['ml'] && source.items[1].details['ml'][0] && source.items[1].details['ml'][0][5] != 0 && source.items[1].details['ml'][0][5] != ''")
                  OddsItem(:odds="source.items[1].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block
                .bettype-col {{ $t("m.CF_ODD") }}
                template(v-if="source.items[0] && source.items[0].details['oe'] && source.items[0].details['oe'][0] && source.items[0].details['oe'][0][5] != 0 && source.items[0].details['oe'][0][5] != ''")
                  OddsItem(:odds="source.items[0].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" label="odd")
                template(v-else)
                  OddsDisabled
          .col-6.efight-odds-group
            .efight-odds.d-block
              .bettype-col {{ $t("m.CF_MLAWAY") }}
              template(v-if="source.items[0] && source.items[0].details['ml'] && source.items[0].details['ml'][0] && source.items[0].details['ml'][0][7] != 0 && source.items[0].details['ml'][0][7] != ''")
                OddsItem(:odds="source.items[0].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
              template(v-else)
                OddsDisabled
            .row.m-0
              .efight-odds.d-block
                .bettype-col {{ $t("m.CF_CS_1_2") }}
                template(v-if="source.items[0] && source.items[0].details['cs'] && source.items[0].details['cs'][1] && source.items[0].details['cs'][1][5] != 0 && source.items[0].details['cs'][1][5] != ''")
                  OddsItem(:odds="source.items[0].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block
                .bettype-col {{ $t("m.CF_CS_0_2") }}
                template(v-if="source.items[0] && source.items[0].details['cs'] && source.items[0].details['cs'][0] && source.items[0].details['cs'][0][5] != 0 && source.items[0].details['cs'][0][5] != ''")
                  OddsItem(:odds="source.items[0].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                template(v-else)
                  OddsDisabled
            .row.m-0.flex-nowrap(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && !racingList7.includes(source.items[0].sportsId)")
              .efight-odds.d-block
                .bettype-col {{ $t("m.CF_R_3_W") }}
                template(v-if="source.items[3] && source.items[3].details['ml'] && source.items[3].details['ml'][0] && source.items[3].details['ml'][0][7] != 0 && source.items[3].details['ml'][0][7] != ''")
                  OddsItem(:odds="source.items[3].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block
                .bettype-col {{ $t("m.CF_R_2_W") }}
                template(v-if="source.items[2] && source.items[2].details['ml'] && source.items[2].details['ml'][0] && source.items[2].details['ml'][0][7] != 0 && source.items[2].details['ml'][0][7] != ''")
                  OddsItem(:odds="source.items[2].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
            .row.m-0.flex-nowrap(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && racingList7.includes(source.items[0].sportsId)")
              .efight-odds.d-block
                .bettype-col {{ $t("m.CF_R_1_W") }}
                template(v-if="source.items[1] && source.items[1].details['ml'] && source.items[1].details['ml'][0] && source.items[1].details['ml'][0][7] != 0 && source.items[1].details['ml'][0][7] != ''")
                  OddsItem(:odds="source.items[1].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block
                .bettype-col {{ $t("m.CF_R_2_W") }}
                template(v-if="source.items[2] && source.items[2].details['ml'] && source.items[2].details['ml'][0] && source.items[2].details['ml'][0][7] != 0 && source.items[2].details['ml'][0][7] != ''")
                  OddsItem(:odds="source.items[2].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block
                .bettype-col {{ $t("m.CF_R_3_W") }}
                template(v-if="source.items[3] && source.items[3].details['ml'] && source.items[3].details['ml'][0] && source.items[3].details['ml'][0][7] != 0 && source.items[3].details['ml'][0][7] != ''")
                  OddsItem(:odds="source.items[3].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
            .row.m-0.flex-nowrap(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && racingList7.includes(source.items[0].sportsId)")
              .efight-odds.d-block
                .bettype-col {{ $t("m.EF8_R2_1STBOOM") }}
                template(v-if="source.items[5] && source.items[5].details['ml'] && source.items[5].details['ml'][0] && source.items[5].details['ml'][0][7] != 0 && source.items[5].details['ml'][0][7] != ''")
                  OddsItem(:odds="source.items[5].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block
                .bettype-col {{ $t("m.EF8_R3_1STBOOM") }}
                template(v-if="source.items[6] && source.items[6].details['ml'] && source.items[6].details['ml'][0] && source.items[6].details['ml'][0][7] != 0 && source.items[6].details['ml'][0][7] != ''")
                  OddsItem(:odds="source.items[6].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
            .row.m-0.flex-nowrap
              .efight-odds.d-block(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && !racingList7.includes(source.items[0].sportsId)")
                .bettype-col {{ $t("m.CF_R_1_W") }}
                template(v-if="source.items[1] && source.items[1].details['ml'] && source.items[1].details['ml'][0] && source.items[1].details['ml'][0][7] != 0 && source.items[1].details['ml'][0][7] != ''")
                  OddsItem(:odds="source.items[1].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block
                .bettype-col {{ $t("m.CF_EVEN") }}
                template(v-if="source.items[0] && source.items[0].details['oe'] && source.items[0].details['oe'][0] && source.items[0].details['oe'][0][7] != 0 && source.items[0].details['oe'][0][7] != ''")
                  OddsItem(:odds="source.items[0].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" label="even")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && racingList7.includes(source.items[0].sportsId)")
                .bettype-col {{ $t("m.EF8_R1_1STBOOM") }}
                template(v-if="source.items[4] && source.items[4].details['ml'] && source.items[4].details['ml'][0] && source.items[4].details['ml'][0][7] != 0 && source.items[4].details['ml'][0][7] != ''")
                  OddsItem(:odds="source.items[4].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled



      //- .efight-marketgroup-content
      //-   .row.justify-content-center.align-items-center.bettype-row
      //-     .col-6.bettype-col {{ $tc("m.BT_HDP", 1) }}
      //-   .row.justify-content-center.m-0
      //-     .col-6.efight-odds-group
      //-       .efight-odds.justify-content-center
      //-         .bettype H
      //-         template(v-if="details['hdp'] && details['hdp'][0] && details['hdp'][0][9] != 0 && details['hdp'][0][10] != 0 && details['hdp'][0][9] != '' && details['hdp'][0][10] != ''")
      //-           OddsItem(:odds="details['hdp'][0]" :idx="details['hdp'][0][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" :mode="'hdp'" count=0 :details="details" homeAway="1")
      //-         template(v-else)
      //-           OddsDisabled
      //-     .col-6.efight-odds-group
      //-       .efight-odds.justify-content-center
      //-         .bettype A
      //-         template(v-if="details['hdp'] && details['hdp'][0] && details['hdp'][0][9] != 0 && details['hdp'][0][10] != 0 && details['hdp'][0][9] != '' && details['hdp'][0][10] != ''")
      //-           OddsItem(:odds="details['hdp'][0]" :idx="details['hdp'][0][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" :mode="'hdp'" count=0 :details="details" homeAway="2")
      //-         template(v-else)
      //-           OddsDisabled
      //-   template(v-if="[43, 44].includes(source.sportsId)")
      //-     .row.justify-content-center.align-items-center.bettype-row
      //-       .col-6.bettype-col {{ $tc("m.BT_OU", 1) }}
      //-         span(v-if="details['ou'] != null && details['ou'][0] != null") ({{ details['ou'][0][8] }})
      //-     .row.justify-content-center.m-0
      //-       .col-6.efight-odds-group
      //-         .efight-odds.justify-content-center
      //-           .bettype O
      //-           template(v-if="details['ou'] && details['ou'][0] && details['ou'][0][11] != 0 && details['ou'][0][12] != 0 && details['ou'][0][11] != '' && details['ou'][0][12] != ''")
      //-             OddsItem(:odds="details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count=0 :details="details" homeAway="1")
      //-           template(v-else)
      //-             OddsDisabled
      //-       .col-6.efight-odds-group
      //-         .efight-odds.justify-content-center
      //-           .bettype U
      //-           template(v-if="details['ou'] && details['ou'][0] && details['ou'][0][11] != 0 && details['ou'][0][12] != 0 && details['ou'][0][11] != '' && details['ou'][0][12] != ''")
      //-             OddsItem(:odds="details['ou'][0]" idx=11 :typ="oddsType" dataType="1" :mode="'ou'" label="under" count=0 :details="details" homeAway="2")
      //-           template(v-else)
      //-             OddsDisabled
      //-   template(v-if="[42].includes(source.sportsId)")
      //-     .row.justify-content-center.align-items-center.bettype-row
      //-       .col-6.bettype-col {{ $tc("m.BT_OE", 1) }}
      //-     .row.justify-content-center.m-0
      //-       .col-6.efight-odds-group
      //-         .efight-odds.justify-content-center
      //-           .bettype O
      //-           template(v-if="details['oe'] && details['oe'][0] && details['oe'][0][5] != 0 && details['oe'][0][5] != ''")
      //-             OddsItem(:odds="details['oe'][0]" idx=5 :typ="oddsType" dataType="2")
      //-           template(v-else)
      //-             OddsDisabled
      //-       .col-6.efight-odds-group
      //-         .efight-odds.justify-content-center
      //-           .bettype E
      //-           template(v-if="details['oe'] && details['oe'][0] && details['oe'][0][7] != 0 && details['oe'][0][7] != ''")
      //-             OddsItem(:odds="details['oe'][0]" idx=7 :typ="oddsType" dataType="2")
      //-           template(v-else)
      //-             OddsDisabled

//- .marble-rafting-group
//-   .eracing-mainmarket-item.collapsed(
//-     v-if="source.items != null && source.items[0] != null && source.items.length == 6"
//-     type='button' 
//-     :id="source.items[0].id"
//-     data-toggle='collapse' 
//-     :data-target="'#mainmarket-' + source.items[0].matchId"
//-   )
//-     efTimer(:source="source.items[0]" :horiz="true" :class="{ 'd-none' : source.items[0].marketId == 3 }")
//-     .live-icon-wrapper(:class="{ 'd-none' : source.items[0].marketId != 3 }")
//-       img.live-icon(src='images/egame/live-icon.svg')
//-       span.mx-1 LIVE
//-       .live-dot
//-   .collapse.show(
//-     :id="'mainmarket-' + source.items[0].matchId"
//-   )
//-     .match-collapse-body
//-       //- small {{ source.items[0].details['ml'][0] }}
//-       .marble-market-group
//-         .winners-market.flex-wrap
//-           .d-flex.align-items-center.justify-content-center.mt-2.mb-2.player-info-wrapper
//-             img.characters(src='images/egame/crown/no1.svg')
//-             .ml-2.player-name-wrapper
//-               | {{ $t("ui.no1") }}
//-           .odds-group-wrapper
//-             .odds-group
//-               .bettype-col {{ $t("m.GR_RED") }} (1)
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[5] && source.items[5].details['cs'] && source.items[5].details['cs'][0] && source.items[5].details['cs'][0][5] != 0 && source.items[5].details['cs'][0][5] != ''")
//-                   OddsItem(:odds="source.items[5].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GR_YELLOW") }} (2)
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[5] && source.items[5].details['cs'] && source.items[5].details['cs'][1] && source.items[5].details['cs'][1][5] != 0 && source.items[5].details['cs'][1][5] != ''")
//-                   OddsItem(:odds="source.items[5].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GR_BLUE") }} (3)
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[5] && source.items[5].details['cs'] && source.items[5].details['cs'][2] && source.items[5].details['cs'][2][5] != 0 && source.items[5].details['cs'][2][5] != ''")
//-                   OddsItem(:odds="source.items[5].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GR_GREEN") }} (4)
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[5] && source.items[5].details['cs'] && source.items[5].details['cs'][3] && source.items[5].details['cs'][3][5] != 0 && source.items[5].details['cs'][3][5] != ''")
//-                   OddsItem(:odds="source.items[5].details['cs'][3]" idx=5 :typ="oddsType" dataType="3")
//-                 template(v-else)
//-                   OddsDisabled
//-           .odds-group-wrapper
//-             .odds-group
//-               .bettype-col {{ $t("m.GR_OVER") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[5] && source.items[5].details['ou'] && source.items[5].details['ou'][0] && source.items[5].details['ou'][0][12] != 0 && source.items[5].details['ou'][0][12] != ''")
//-                   OddsItem(:odds="source.items[5].details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count=0 :details="source.items[5].details" homeAway="1")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GR_UNDER") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[5] && source.items[5].details['ou'] && source.items[5].details['ou'][0] && source.items[5].details['ou'][0][11] != 0 && source.items[5].details['ou'][0][11] != ''")
//-                   OddsItem(:odds="source.items[5].details['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count=0 :details="source.items[5].details" homeAway="2")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GR_ODD") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[5] && source.items[5].details['oe'] && source.items[5].details['oe'][0] && source.items[5].details['oe'][0][5] != 0 && source.items[5].details['oe'][0][5] != ''")
//-                   OddsItem(:odds="source.items[5].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" label="odd")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GR_EVEN") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[5] && source.items[5].details['oe'] && source.items[5].details['oe'][0] && source.items[5].details['oe'][0][7] != 0 && source.items[5].details['oe'][0][7] != ''")
//-                   OddsItem(:odds="source.items[5].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" label="even")
//-                 template(v-else)
//-                   OddsDisabled
//-         .normal-market.pb-0
//-           .bettype {{ $t("ui.best_3_balls") }}
//-           .odds-group-wrapper
//-             .odds-group
//-               .bettype-col {{ $t("m.GR_SINGLE") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[4] && source.items[4].details['oxt'] && source.items[4].details['oxt'][0]")
//-                   OddsItem(:odds="source.items[4].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GR_PAIR") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[4] && source.items[4].details['oxt'] && source.items[4].details['oxt'][0]")
//-                   OddsItem(:odds="source.items[4].details['oxt'][0]" idx=6 :typ="oddsType" dataType="2")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GR_TRIPS") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[4] && source.items[4].details['oxt'] && source.items[4].details['oxt'][0]")
//-                   OddsItem(:odds="source.items[4].details['oxt'][0]" idx=7 :typ="oddsType" dataType="2")
//-                 template(v-else)
//-                   OddsDisabled
//-         .normal-market.d-flex
//-           .flex-grow-1
//-             .red-team
//-               img(src='images/egame/marble-rafting-characters/red.svg')
//-               span {{ $t("ui.red") }}
//-             .odds-group-wrapper
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_ADVANCED") }}
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[0] && source.items[0].details['ml'] && source.items[0].details['ml'][0]")
//-                     OddsItem(:odds="source.items[0].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_ELIMINATED") }}
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[0] && source.items[0].details['ml'] && source.items[0].details['ml'][0]")
//-                     OddsItem(:odds="source.items[0].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-             .odds-group-wrapper
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_HIT1") }} (1)
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[0] && source.items[0].details['cs'] && source.items[0].details['cs'][0] && source.items[0].details['cs'][0][5] != 0 && source.items[0].details['cs'][0][5] != ''")
//-                     OddsItem(:odds="source.items[0].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_HIT2") }} (2)
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[0] && source.items[0].details['cs'] && source.items[0].details['cs'][1] && source.items[0].details['cs'][1][5] != 0 && source.items[0].details['cs'][1][5] != ''")
//-                     OddsItem(:odds="source.items[0].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_PERFECT") }} (3)
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[0] && source.items[0].details['cs'] && source.items[0].details['cs'][2] && source.items[0].details['cs'][2][5] != 0 && source.items[0].details['cs'][2][5] != ''")
//-                     OddsItem(:odds="source.items[0].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-           .flex-grow-1
//-             .yellow-team
//-               img(src='images/egame/marble-rafting-characters/yellow.svg')
//-               span {{ $t("ui.yellow") }}
//-             .odds-group-wrapper
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_ADVANCED") }}
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[1] && source.items[1].details['ml'] && source.items[1].details['ml'][0]")
//-                     OddsItem(:odds="source.items[1].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_ELIMINATED") }}
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[1] && source.items[1].details['ml'] && source.items[1].details['ml'][0]")
//-                     OddsItem(:odds="source.items[1].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-             .odds-group-wrapper
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_HIT1") }} (1)
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[1] && source.items[1].details['cs'] && source.items[1].details['cs'][0] && source.items[1].details['cs'][0][5] != 0 && source.items[1].details['cs'][0][5] != ''")
//-                     OddsItem(:odds="source.items[1].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_HIT2") }} (2)
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[1] && source.items[1].details['cs'] && source.items[1].details['cs'][1] && source.items[1].details['cs'][1][5] != 0 && source.items[1].details['cs'][1][5] != ''")
//-                     OddsItem(:odds="source.items[1].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_PERFECT") }} (3)
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[1] && source.items[1].details['cs'] && source.items[1].details['cs'][2] && source.items[1].details['cs'][2][5] != 0 && source.items[1].details['cs'][2][5] != ''")
//-                     OddsItem(:odds="source.items[1].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-         .normal-market.d-flex
//-           .flex-grow-1
//-             .blue-team
//-               img(src='images/egame/marble-rafting-characters/blue.svg')
//-               span {{ $t("ui.blue") }}
//-             .odds-group-wrapper
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_ADVANCED") }}
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[2] && source.items[2].details['ml'] && source.items[2].details['ml'][0]")
//-                     OddsItem(:odds="source.items[2].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_ELIMINATED") }}
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[2] && source.items[2].details['ml'] && source.items[2].details['ml'][0]")
//-                     OddsItem(:odds="source.items[2].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-             .odds-group-wrapper
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_HIT1") }} (1)
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[0] && source.items[2].details['cs'] && source.items[2].details['cs'][0] && source.items[2].details['cs'][0][5] != 0 && source.items[2].details['cs'][0][5] != ''")
//-                     OddsItem(:odds="source.items[2].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_HIT2") }} (2)
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[2] && source.items[2].details['cs'] && source.items[2].details['cs'][1] && source.items[2].details['cs'][1][5] != 0 && source.items[2].details['cs'][1][5] != ''")
//-                     OddsItem(:odds="source.items[2].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_PERFECT") }} (3)
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[2] && source.items[2].details['cs'] && source.items[2].details['cs'][2] && source.items[2].details['cs'][2][5] != 0 && source.items[2].details['cs'][2][5] != ''")
//-                     OddsItem(:odds="source.items[2].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-           .flex-grow-1
//-             .green-team
//-               img(src='images/egame/marble-rafting-characters/green.svg')
//-               span {{ $t("ui.green") }}
//-             .odds-group-wrapper
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_ADVANCED") }}
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[3] && source.items[3].details['ml'] && source.items[3].details['ml'][0]")
//-                     OddsItem(:odds="source.items[3].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_ELIMINATED") }}
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[3] && source.items[3].details['ml'] && source.items[3].details['ml'][0]")
//-                     OddsItem(:odds="source.items[3].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-             .odds-group-wrapper
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_HIT1") }} (1)
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][0] && source.items[3].details['cs'][0][5] != 0 && source.items[3].details['cs'][0][5] != ''")
//-                     OddsItem(:odds="source.items[3].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_HIT2") }} (2)
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][1] && source.items[3].details['cs'][1][5] != 0 && source.items[3].details['cs'][1][5] != ''")
//-                     OddsItem(:odds="source.items[3].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-               .odds-group
//-                 .bettype-col {{ $t("m.GR_PERFECT") }} (3)
//-                 template(v-if="source.items[0].marketId == 3")
//-                   OddsDisabled
//-                 template(v-else)
//-                   template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][2] && source.items[3].details['cs'][2][5] != 0 && source.items[3].details['cs'][2][5] != ''")
//-                     OddsItem(:odds="source.items[3].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled

</template>

<script>
import config from "@/config";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    efTimer: () => import("@/components/mobile/efight/efTimer"),
    OddsItem: () => import("@/components/mobile/main/xitem/oddsItem"),
    OddsDisabled: () => import("@/components/mobile/main/xitem/oddsDisabled")
  },
  mixins: [mixinHDPOUOdds],
  props: {
    source: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: { 
    oddsType() {
      return this.$store.getters.pageDisplay.oddsType;
    },
    racingList(){
      return config.racingList;
    },
    racingList7() {
      return config.racingList7;
    },
    newFeatures() {
      return config.newFeatures
    }
   },
  methods: {
    team(player, pos, isTeam) {
      if(isTeam) {
        var n = player.homeTeam;
        return n;
      } else {
        var n = player.homeTeam.split(" - ")[pos];
        return n;
      }
    },
    getImage(s, img) {
      return config.resourceImgUrl + "/ef/" + (this.newFeatures ? 'uat/' : 'prod/') + s + "/" + img + ".png";
    }
  }
};
</script>